import { gql } from '@apollo/client'
import PHYSICAL_FORM_FRAGMENT from 'apollo/fragments/PHYSICAL_FORM_FRAGMENT'

// SELDON_BEATTIE_INPUTS

export default gql`
  query seldonBeattieInputs {
    input_annual_physical_form {
      smoking_attestation {
        ...PHYSICAL_FORM_FRAGMENT
      }
    }
  }
  ${PHYSICAL_FORM_FRAGMENT}
`
